module.exports = __webpack_public_path__ + "static/media/analitics.b02497b3.svg";